export default (url: string): boolean =>
    typeof url === 'string' && url.match(/^tel:/) !== null
